import AuditSections from "const/AuditSections";
import DataStatuses from "const/DataStatuses";
import DateTimeFormats from "const/DateTimeFormats";
import TaskTypes from "const/TaskTypes";
import moment from "moment";

const AUDIT_TO_CHECK = [
  AuditSections.AMOUNT_DEVIATION,
  AuditSections.DUPLICATES,
  AuditSections.NO_ATTACHMENT,
  AuditSections.NO_CLASS,
  AuditSections.NO_LOCATION,
  AuditSections.NO_PAYEE,
  AuditSections.NO_PROJECT,
  AuditSections.POSTED_TO_PARENT,
  AuditSections.SIMILAR_PAYEE,
  AuditSections.UNUSUAL_AMOUNT,
  AuditSections.UNUSUAL_CATEGORY,
  AuditSections.UNUSUAL_TAX
];

export default class Tasks {
  static checkIsAutoTaskCompleted({ type, startDate, stats = {}, accountsData }) {
    const monthKey = moment(startDate).format(DateTimeFormats.API_MONTH_DATE);

    switch (type) {
      case TaskTypes.TRANSACTIONS:
        return ![
          DataStatuses.TO_RECONCILE,
          DataStatuses.NEED_REACTION,
          DataStatuses.TO_REVIEW
        ].some((status) => stats?.[status]?.byMonth?.[monthKey]?.count);
      case TaskTypes.DOCUMENTS:
        return ![DataStatuses.TO_REVIEW].some((status) => stats?.[status]?.byMonth?.[monthKey]?.count);
      case TaskTypes.AUDIT:
        return !AUDIT_TO_CHECK.some((audit) => stats?.[audit]?.byMonth?.[monthKey]?.count);
      case TaskTypes.BANK_FEEDS:
        return !(accountsData.filter(({ extraData = {} }) => {
          return extraData.xeroBankFeedDisconnected || extraData.quickBooksBankFeedDisconnected;
        }).length);
      default:
        return false;
    }
  }
}
